import structuredFilterUtils from '@/features/StructuredFilter/utils/structuredFilter.utils';
import {
  ACCOUNT_COLUMNS,
  AGENT_COLUMNS,
  CONTACT_COLUMNS,
  FEEDBACK_COLUMNS,
} from '@/types/filterKeyConst';

const getDomain = (columnKey: string) => {
  const isAccount = Object.values(ACCOUNT_COLUMNS).find(
    (col) => col === columnKey,
  );
  if (isAccount) return 'Account';
  const isContact = Object.values(CONTACT_COLUMNS).find(
    (col) => col === columnKey,
  );
  if (isContact) return 'Contact';
  const isAgent = Object.values(AGENT_COLUMNS).find((col) => col === columnKey);
  if (isAgent) return 'Agent';
  return null;
};

const getSearchTitle = (
  query: string | undefined,
  filter: StructuredFilterQueryFormatT[],
  getColumnName: (columnKey: string) => string,
) => {
  if (query) {
    return query;
  }

  // 타이틀 생성 시 제외해야할 컬럼 목록
  const excludeColumns: string[] = [FEEDBACK_COLUMNS.ENTITY_GROUP];

  let firstFilter: StructuredFilterQueryFormatT;
  firstFilter = filter.filter(
    (f) => !excludeColumns.includes(f.columnKey),
  )?.[0];

  if (!firstFilter) {
    throw new Error('[Error] getSearchTitle : invalid filter list');
  }

  const operator = firstFilter.operator;
  const operatorText = structuredFilterUtils.getOperatorTextMap({
    operator,
    isMultiValueField: true,
    hasMultiValues: firstFilter.filterValues.length > 1,
  });

  const filterName = `${getColumnName(
    firstFilter.columnKey,
  )} ${operatorText} ${firstFilter.filterValues
    .map((value) => value.filterName)
    .join(', ')}`;
  return filterName;
};

const getOriginalFilterSet = (filter: KeyLabelSetFilter) => {
  const newSet: Record<string, string> = {};

  if (filter.set[FEEDBACK_COLUMNS.SNIPPET]) {
    newSet[FEEDBACK_COLUMNS.SNIPPET] = filter.set[FEEDBACK_COLUMNS.SNIPPET];
  }
  if (filter.set[FEEDBACK_COLUMNS.ENTITY_GROUP]) {
    newSet[FEEDBACK_COLUMNS.ENTITY_GROUP] =
      filter.set[FEEDBACK_COLUMNS.ENTITY_GROUP];
  }
  if (filter.set[FEEDBACK_COLUMNS.DATE_START]) {
    newSet[FEEDBACK_COLUMNS.DATE_START] =
      filter.set[FEEDBACK_COLUMNS.DATE_START];
  }
  if (filter.set[FEEDBACK_COLUMNS.DATE_END]) {
    newSet[FEEDBACK_COLUMNS.DATE_END] = filter.set[FEEDBACK_COLUMNS.DATE_END];
  }

  return newSet;
};

const searchQueryUtils = {
  getDomain,
  getSearchTitle,
  getOriginalFilterSet,
};

export default searchQueryUtils;
